import CompleteProfilePage, { CompleteProfilePageProps } from './CompleteProfilePage';

export type { CompleteProfilePageProps };
export default CompleteProfilePage;
